import { useEffect, useRef } from 'react'

function usePreviousV2<T>(value: T) {
    const ref = useRef<T>()

    useEffect(() => {
        ref.current = value
    }, [value])

    return ref
}

export default usePreviousV2
